/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { DeclineInvitationMutationResponse, DeclineInvitationPathParams, DeclineInvitation400, DeclineInvitation401, DeclineInvitation403, DeclineInvitation404, DeclineInvitation409, DeclineInvitation500 } from "../../types/staffController/DeclineInvitation.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getDeclineInvitationUrl(invitationId: DeclineInvitationPathParams["invitationId"]) {
  const res = { method: 'POST', url: `/api/invitations/${invitationId}/decline` as const }
  return res
}

/**
 * @summary Decline one of the signed-in user's pending invitations
 * {@link /api/invitations/:invitationId/decline}
 */
export async function declineInvitation(invitationId: DeclineInvitationPathParams["invitationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DeclineInvitationMutationResponse, ResponseErrorConfig<DeclineInvitation400 | DeclineInvitation401 | DeclineInvitation403 | DeclineInvitation404 | DeclineInvitation409 | DeclineInvitation500>, unknown>({ method : "POST", url : getDeclineInvitationUrl(invitationId).url.toString(), ... requestConfig })
  return res.data
}